import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

/**
 * Cerimonia di salvataggio della chiave di recupero, al PRIMO CARICAMENTO.
 *
 * PERCHE' QUI E NON ALLA REGISTRAZIONE.
 * Prima questo schermo compariva subito dopo la registrazione, prima ancora
 * che l'utente avesse visto il prodotto. Misurato sui dati veri: dei 162
 * utenti arrivati dal browser interno di Facebook o Instagram, il 49% se ne
 * andava entro 77 secondi, e il tasso di pagamento era del 9% contro il 23%
 * di chi usava un browser normale — stessa sorgente, stesso annuncio, cambiava
 * solo il browser. Un ostacolo messo prima che uno capisca cosa sta comprando
 * si paga tutto in abbandoni.
 *
 * UN SOLO GESTO (2026-09-04, terza revisione): "Copia la chiave e continua".
 * Un tocco che copia, registra la conferma sul server e fa partire il
 * caricamento. Sotto, in secondo piano, "Scarica come file e continua", che
 * fa lo stesso scaricando. NESSUN PULSANTE DISABILITATO, nessuna casella,
 * nessuna riscrittura di caratteri: le versioni precedenti chiedevano prima
 * di salvare e POI di dichiararlo con un secondo gesto, e il pulsante di
 * conferma nasceva grigio — chi lo premeva subito non vedeva succedere
 * niente, pensava che il sito fosse rotto e se ne andava. L'azione di
 * salvare E' la conferma, e il testo del pulsante lo dice.
 *
 * NIENTE VICOLI CIECHI. Se la clipboard nega (browser interno di Facebook:
 * esattamente il pubblico da non perdere), la chiave resta selezionata a
 * schermo, compare l'avviso di copiarla a mano, e il caricamento parte lo
 * stesso — la schermata resta aperta per la copia manuale e la riga in
 * fondo diventa "Chiudi". Se e' il download a fallire (dentro Facebook
 * fallisce in silenzio), si resta qui con l'invito a usare la copia.
 *
 * IL CARICAMENTO RESTA FERMO finche' la cerimonia non e' finita, ed E'
 * RIPETIBILE: il token vive in sessionStorage finche' non e' confermato,
 * un ricaricamento lo ritrova identico (nel vecchio schermo un reload
 * faceva perdere la chiave per sempre, perche' stava nello stato di React).
 */
export default function CerimoniaChiave({ onFatto, onContinuaSenzaChiudere, onAnnulla, nomeFile }) {
  const { t } = useTranslation('vault');
  const { preparaChiaveDiRecupero, confermaChiaveDiRecupero } = useAuth();

  const [chiave, setChiave] = useState(null);
  const [errore, setErrore] = useState('');
  const [inCorso, setInCorso] = useState(false);
  // Il caricamento e' gia' partito ma la schermata e' rimasta aperta per la
  // copia manuale (clipboard negata): la riga in fondo diventa "Chiudi".
  const [avviatoConCopiaManuale, setAvviatoConCopiaManuale] = useState(false);

  useEffect(() => {
    let vivo = true;
    preparaChiaveDiRecupero()
      .then((k) => { if (vivo) setChiave(k); })
      .catch(() => { if (vivo) setErrore(t('chiave_errore_generica')); });
    return () => { vivo = false; };
  }, [preparaChiaveDiRecupero, t]);

  function selezionaChiave() {
    const el = document.getElementById('cc-chiave');
    if (el) {
      const r = document.createRange(); r.selectNodeContents(el);
      const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
    }
  }

  // Registra la conferma sul server. Restituisce true se e' andata; su errore
  // di rete mostra il messaggio e lascia la schermata dov'e' — i pulsanti
  // restano attivi per riprovare.
  async function conferma() {
    setInCorso(true); setErrore('');
    try {
      await confermaChiaveDiRecupero(chiave);
      return true;
    } catch {
      setErrore(t('chiave_errore_salvataggio'));
      setInCorso(false);
      return false;
    }
  }

  async function copiaEContinua() {
    if (inCorso || avviatoConCopiaManuale) return;
    let copiata = true;
    try {
      await navigator.clipboard.writeText(chiave);
    } catch {
      copiata = false;
    }
    if (copiata) {
      if (await conferma()) onFatto();
      return;
    }
    // Clipboard negata: selezione manuale, avviso, e si continua LO STESSO —
    // il caricamento parte mentre la schermata resta aperta per copiare a
    // mano. Mai un vicolo cieco.
    selezionaChiave();
    if (await conferma()) {
      setErrore(t('chiave_copia_fallita'));
      setInCorso(false);
      setAvviatoConCopiaManuale(true);
      if (onContinuaSenzaChiudere) onContinuaSenzaChiudere();
      else onFatto();
    }
  }

  async function scaricaEContinua() {
    if (inCorso) return;
    try {
      const testo = [
        t('chiave_file_intestazione'), '================================', '',
        t('chiave_file_etichetta'), chiave, '',
        '================================', t('chiave_file_conserva'),
      ].join('\n');
      const url = URL.createObjectURL(new Blob([testo], { type: 'text/plain' }));
      const a = document.createElement('a');
      a.href = url; a.download = t('chiave_file_nome');
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch {
      setErrore(t('chiave_download_fallito'));
      return;
    }
    // Se il caricamento e' gia' partito (copia manuale), la conferma e' gia'
    // registrata: qui si e' solo scaricato il file in piu', non si riparte.
    if (avviatoConCopiaManuale) return;
    if (await conferma()) onFatto();
  }

  return (
    <div className="cc-overlay" role="dialog" aria-modal="true" aria-labelledby="cc-titolo">
      <div className="cc-card">
        <h2 id="cc-titolo">{t('chiave_titolo')}</h2>
        <p className="cc-sottotitolo">
          {nomeFile ? t('chiave_sottotitolo_con_file', { nome: nomeFile }) : t('chiave_sottotitolo')}
        </p>

        {!chiave ? (
          <div className="cc-attesa">{t('chiave_generazione')}</div>
        ) : (
          <>
            {/* Grande, monospazio e selezionabile: dev'essere leggibile da uno
                schermo di telefono e copiabile a mano se la clipboard nega. */}
            <div className="cc-chiave-box">
              <code id="cc-chiave" className="cc-chiave">{chiave}</code>
            </div>

            <button type="button" className="cc-copia" onClick={copiaEContinua}>
              {inCorso ? t('chiave_salvataggio') : t('chiave_copia_continua')}
            </button>
            <button type="button" className="cc-scarica" onClick={scaricaEContinua}>
              {t('chiave_scarica_continua')}
            </button>

            {/* Una riga sola d'avviso, senza emoji. */}
            <p className="cc-avviso">{t('chiave_avviso')}</p>

            {errore && <div className="cc-errore">⚠ {errore}</div>}

            {avviatoConCopiaManuale ? (
              /* Il caricamento e' gia' partito: qui si chiude soltanto. */
              <button type="button" className="cc-annulla" onClick={onAnnulla}>
                {t('chiave_chiudi')}
              </button>
            ) : (
              /* Annullare non salta la cerimonia: chiude questo schermo e il
                 caricamento resta fermo. Il file scelto non viene perso. */
              <button type="button" className="cc-annulla" onClick={onAnnulla}>
                {t('chiave_annulla')}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
